<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <sig-r-data-table 
          :items="comparativos"
          :loading="loading"
          @recharge="getComparativosSigR()"
          @switchProcessamentosExpirados="
            processamentosExpirados = $event,
            getComparativosSigR()
          "
        /> 
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SigRComparaService from '@/services/SigRComparaService';
import dayjs from 'dayjs';
import tourMixins from '@/mixins/tourMixins';
import dateFormatterMixins from '@/mixins/dateFormatterMixins';
import pusherMixins from '@/mixins/pusherMixins';

export default {

  components: {
    SigRDataTable: () => import('@/components/sigRCompara/SigRDataTable')
  },
  mixins: [dateFormatterMixins, pusherMixins, tourMixins],

  data() {
    return {
      comparativos: [],
      loading: false,
      processamentosExpirados: false,
      arrTour: [
        {
          element: '#btn-novo-comparativo',
          intro: 'Clicando neste botão você poderá criar novos comparativos.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#comparativo-historico-search',
          intro: 'Neste campo você poderá pesquisar por comparativos já existentes.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#action-download-comparativo',
          intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado de seu comparativo.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#action-edit-comparativo',
          intro: 'Clicando neste ícone você poderá editar seu comparativo.',
          scrollTo: 'tooltip',
          position: 'left'
        },   
        {
          element: '#action-more-comparativo',
          intro: 'Aqui você acessa outras opções para seu comparativo, como ver mais detalhes, executá-lo novamente, duplicá-lo ou deletá-lo.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ]
    };
  },

  mounted() {
    this.getComparativosSigR();
    this.subscribe();   
  },

  methods: {
    subscribe() {
      this.pusherChannel.bind('reload-pag-calculo-comparativo', () => {
        this.getComparativosSigR();
      });
    },

    getComparativosSigR() {
      this.loading = true;
      this.comparativos = [];
      SigRComparaService.getComparativos(this.processamentosExpirados).then(response => {
        response.data.comparativos.forEach(element => {

          let obj = {
            id: element.id,
            titulo: element.titulo,
            status: element.status,
            origem_ais: element.origem_ais,
            data_bdgd: element.data_bdgd ? this.formatMonth(element.data_bdgd) : '-',
            data_ais: element.data_ais ? this.formatMonth(element.data_ais) : '-',
            data_imobilizacao_inicio: element.data_imobilizacao_inicio ? this.formatMonth(element.data_imobilizacao_inicio) : '-',
            data_imobilizacao_fim: element.data_imobilizacao_fim ? this.formatMonth(element.data_imobilizacao_fim) : '-',
            sobra_fisica: element.sobra_fisica ? 'Sim' : 'Não',
            tipo: !element.bdgd ? 'SIG-R Completa' : 'Apenas BDGD',
            compara_ti: element.compara_ti ? 'Sim' : 'Não',
            compara_ano: element.anual ? 'Sim' : 'Não',
            tucs: element.tucs,
            data_processamento: element.data_processamento ? dayjs(element.data_processamento).format('DD/MM/YYYY HH:mm') : '-',
            usuario: element.usuario.nome,
            usuario_id: element.usuario.id
          };

          if (element.odis) {
            let arrayODI = '[' + element.odis.replaceAll('\'', '"') + ']';
            obj.odis = JSON.parse(arrayODI);
          } else {
            obj.odis = ''; 
          }

          this.comparativos.push(obj);
        });
      })
        .catch(error => {
          console.error(error);
          this.$toast.error('Erro ao recuperar comparativos.', '', {position:'topRight'});
        })
        .finally(() =>{ this.loading = false, this.iniciarTourPagina(); });
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
  
      let arrTourFormatted = this.comparativos.length ? this.arrTour : this.arrTour.splice(0, 2);
      this.iniciarTour(arrTourFormatted);
    }
  }
};
</script>